export default __webpack_public_path__ + "static/SRUS SBP205 - Product Specifications & Technical Data-13f4b95b9db42ea60fffe67337bed2aa.pdf";